import { gql } from "@apollo/client";

const GET_OPT_IN = gql`
    query institutionOptInStatus{
        institutionOptInStatus {
        opt_in
        }
    }`
;

export default GET_OPT_IN;
